module.exports = __webpack_public_path__ + "img/sesion_expirada.71547807.png";